@if (appDataService.appData$ | async; as appData) {
  @if (!appData.errors) {
    <lti-root-view></lti-root-view>
  }
  @if (appData.errors) {
    <app-error></app-error>
  }
}
